'use client';

import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { analytics } from 'lib/analytics/analytics';
import { PictureIcon } from 'assets/icons';
import { useModal } from 'components/shared';
import { CarouselPillButton } from 'components/shared/CarouselPillButton';
import {
  ProductCarousel,
  ProductCarouselItem,
} from 'components/shared/ProductCarousel';
import { RingProColors } from 'content/products/ring-pro';
import { RingProRealLifeImagesModalContent } from './RealLifeImagesModalContent';
import { CarouselFooterCard } from '../../ring-air/CarouselFooterCard';
import { OffersDataType } from '../../ring-air/OffersCarousel';
import styles from './RingProProductCarousel.module.css';

// TODO: RING PRO IMPROVEMENTS - Set to true once Ring Pro lifestyle images are uploaded
export const ENABLE_REAL_LIFE_IMAGES = false;

interface RingProProductCarouselProps {
  className?: string;
  items: readonly ProductCarouselItem[];
  selectedColor: RingProColors;
  sticky?: boolean;
  footerItems?: OffersDataType[];
}

const RingProProductCarouselBase = ({
  className,
  items,
  selectedColor,
  sticky = false,
  footerItems,
}: RingProProductCarouselProps) => {
  const t = useTranslations('ring');
  const ModalClient = useModal();

  const handleImagePreview = useCallback(() => {
    analytics.track('ring-pro-real-life-images-clicked', {
      clicked: true,
    });
    ModalClient.set(
      <RingProRealLifeImagesModalContent selectedColor={selectedColor} />,
    );
    ModalClient.setPortal(true);
    ModalClient.show();
  }, [ModalClient, selectedColor]);

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div className="carousel-image-area">
        <ProductCarousel
          items={[...items]}
          sticky={sticky}
          buttonVariant="glass"
          // navigationType="cursorTracked"
          // autoSlideDuration={4.2}
        />
        {ENABLE_REAL_LIFE_IMAGES && (
          <CarouselPillButton
            className="real-images-pill"
            icon={<PictureIcon />}
            label={t('ring.VIEW_REAL_LIFE')}
            onClick={handleImagePreview}
            aria-label={t('ring.VIEW_REAL_LIFE')}
          />
        )}
      </div>
      {footerItems && footerItems.length > 0 && (
        <CarouselFooterCard className="carousel-footer" data={footerItems} />
      )}
    </div>
  );
};

export const RingProProductCarousel = RingProProductCarouselBase;
